import CookieConsent from './components/cookie-consent'

window.cookieConsent = new CookieConsent($)

$.wxCookieConsent({
    cookieGroups: { 'analyticsCookies': ['_ga','_gid'], 'comfortCookies': [] },
    dataLayerPush: true,
    headerTitle : CCheaderTitle,
    headerText : CCheaderText,
    compulsoryLabel: CCcompulsoryLabel,
    compulsoryText: CCcompulsoryText,
    analyticsLabel: CCanalyticsLabel,
    analyticsText: CCanalyticsText,
    comfortLabel: CCcomfortLabel,
    comfortText: CCcomfortText,
    acceptLabel: CCacceptLabel,
    footerText: CCfooterText,
    cookieSettingsText: CCcookieSettingsText,
    buttonCustomClass: 'btn btn-secondary',
    comfortOption: true,
    compact: false,
    layout: 'full',
    optionalsCheked: false
})
